export const isInIframe = () => {
  // if (window.location.host === '127.0.0.2:3000') {
  //   return true;
  // }

  try {
    return window.self !== window.top;
  } catch (e) {
    // SecurityError: Blocked a frame with origin from accessing a cross-origin frame.
    // This means it's cross-origin embedded → definitely in an iframe
    return true;
  }
};
